import { atom } from 'recoil';

import { ATOMS } from './constants';

export const cachedRoute = atom<string | undefined>({
  key: ATOMS.CACHED_ROUTE,
  default: undefined
});
